<template>
  <div>
    <transition name="el-zoom-in-top">
      <div
        class="down-list"
        v-if="visible"
        :style="{ top: top + 'px', right: right + 'px' }"
      >
        <div class="down-info">
          <el-avatar :size="48" class="avator">{{
            userInfo.userName ? userInfo.userName.slice(0, 1) : "-"
          }}</el-avatar>
          <div class="down-text">
            <span class="customname">{{ userInfo.userName }}</span>
            <span class="text-comp">{{ userInfo.compCnName }}</span>
          </div>
        </div>
        <div class="down-btn">
          <div
            v-for="(item, index) in  userInfo.compType==2 ?downList : downList1"
            :key="index"
          >
            <div @click="handleSwitchUser(item)" class="down-btn-info" v-if="item.type !== 2 && item.type !== 3">{{ item.label }}</div>
          </div>
          <transition name="el-fade-in-linear">
            <div class="switch-user" v-show="switchUserVisible">
              <div class="switch-top">
                <div class="switch-text">当前用户下的企业</div>
                <div class="switch-url" @click="handleAdministration">
                  企业管理
                </div>
              </div>
              <div class="enterprise-list">
                <div
                  class="enterprise-item"
                  v-for="(item, index) in comList"
                  :key="index"
                  :class="index == activate ? 'enterprise-item-activate' : ''"
                  @click="handleActivate(index, item)"
                >
                  <img
                    class="item-img"
                    v-if="item.logoUrl"
                    :src="`${companyLogoUrl}${item.logoUrl}`"
                    alt=""
                  />

                  <el-avatar v-else :size="40" class="item-img">{{
                    item.compCnName ? item.compCnName.slice(0, 1) : "-"
                  }}</el-avatar>
                  <div class="item-info">
                    <div class="item-left">
                      <el-popover
                        trigger="hover"
                        :content="item.compCnName"
                        placement="top"
                        :disabled="!item.tooltipFlag"
                        width="300"
                        :teleported="false"
                      >
                        <template #reference>
                          <div
                            @mouseenter="handleMouseenter(item, $event)"
                            class="left-top"
                          >
                            {{ item.compCnName }}
                          </div>
                        </template>
                      </el-popover>
                      <div class="left-tag" v-if="item.compType == 1">
                        <div class="tag-gy tag">
                          {{ item.identityText }}
                        </div>
                        <div class="tag tag-gy-dj">
                          <img :src="vipUrl[item.memberType].url" alt="" />
                          <span>{{ vipUrl[item.memberType].text }}</span>
                        </div>
                      </div>
                      <div class="left-tag" v-else-if="item.compType == 2">
                        <div class="tag-cg tag">
                          {{ item.identityText }}
                        </div>

                        <div
                          class="tag tag-cg-dj1"
                          v-if="item.memberType && item.memberType == 1"
                        >
                          基础版
                        </div>
                        <div
                          class="tag tag-cg-dj"
                          v-else-if="item.memberType && item.memberType == 2"
                        >
                          高级版
                        </div>
                      </div>

                      <div class="left-tag" v-else-if="item.compType == 3">
                        <div class="tag-fw tag">
                          {{ item.identityText }}
                        </div>
                      </div>
                    </div>

                    <i
                      :style="{
                        visibility: index == activate ? 'initial' : 'hidden',
                      }"
                      class="el-icon-check item-right"
                    ></i>
                  </div>
                </div>
              </div>
              <div class="add-comp">
                <div class="add-btn" @click="handleCreateDialog">
                  <i class="el-icon-circle-plus-outline add-icon"></i>创建企业
                </div>
              </div>
            </div>
          </transition>
        </div>
          <div v-if="userInfo.grantType" @click="handleSwitchUser({ type: 3 })" class="multi"
         >切换账号
        </div>
        <div class="down-out" @click="handleUserLogout">退出登录</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { companyLogoUrl } from "@/utils/config.js";

export default {
  name: "DropDownList",
  props: {
    visible: Boolean,
    comList: Array,
    switchUserVisible: Boolean,
    activate: Number,
    top: Number,
    right: Number,
    multiUserMax:Number
  },
  data() {
    return {
      companyLogoUrl,
      userInfo: this.$store.state.userInfo,
      downList: [
        {
          label: "账号安全",
          type: 1,
        },
        // {
        //   label: "语言",
        //   type: 2,
        // },
        {
          label: "切换账号",
          type: 3,
        },
      ],
 downList1 : [
  {
    label: "账号安全",
    type: 1,
  },
  // {
  //   label: "语言",
  //   type: 2,
  // },
 //  {
//  label: "切换账号",
//    type: 3,
// },
  {
    label: "我的会员信息",
    type: 4,
  },
  {
    label: "升级会员级别",
    type: 5,
  },
],
      vipUrl: {
        0: {
          url: "https://res.haizol.com/base/images/membership/new/vip0.png",
          text: "普通会员",
        },
        1: {
          url: "https://res.haizol.com/base/images/membership/new/vip_gold.png",
          text: "黄金会员",
        },
        2: {
          url: "https://res.haizol.com/base/images/membership/new/vip_platinum.png",
          text: "铂金会员",
        },
        3: {
          url: "https://res.haizol.com/base/images/membership/new/vip_diamond.png",
          text: "钻石会员",
        },
        4: {
          url: "https://res.haizol.com/base/images/membership/new/vip_lifetime.png",
          text: "VIP会员",
        },
        5: {
          url: "https://res.haizol.com/base/images/membership/new/vip_platinum.png",
          text: "铂金会员",
        },
        6: {
          url: "https://res.haizol.com/base/images/membership/vip_smartshow.png",
          text: "智展宝",
        },
        7: {
          url: "https://res.haizol.com/base/images/membership/new/vip_vvip.png",
          text: "至尊VVIP会员",
        },
        8: {
          url: "https://res.haizol.com/base/images/membership/new/vip_engineering_expansion.png",
          text: "工脉拓会员",
        },
      },
    };
  },
  methods: {
    handleAdministration() {
      this.$emit("Administration");
    },
    handleSwitchUser(item) {
      this.$emit("SwitchUser", item);
    },
    handleActivate(index, item) {
      this.$emit("cutActivate", index, item);
    },
    handleUserLogout() {
      this.$emit("UserLogout");
    },
    handleCreateDialog() {
      if (this.userInfo.loginAsManagerId>0) {
        return  this.$message.error("演示模式无权限进行操作");
      }
      if (this.comList.length === this.multiUserMax) {
        return  this.$message.warning("账号创建数量已达系统上限");
      }else{
        this.$emit("CreateDialog");

      }
      
    },
    handleMouseenter(item, event) {
      const ev = event.target;
      if (ev.clientHeight < ev.scrollHeight) {
        // 如果实际内容高度 > 文本高度 ，就代表内容溢出了
        item.tooltipFlag = true;
      } else {
        item.tooltipFlag = false;
        // 否则为不溢出
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.down-list {
  position: absolute;
  border-radius: 4px;
  border: 0.5px solid #cfd5df;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 20, 51, 0.1);
  // width: 120px;
  // padding: 16px 0;
  top: 34px;
  z-index: 999;
  right: 0;
  .down-info {
    display: flex;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid rgba(237, 240, 244, 1);
    .avator {
      margin-right: 8px;
      color: #fff;
      line-height: 48px;
      background-color: #256bff;
    }
    .down-text {
      height: 44px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-style: normal;
      line-height: normal;
      font-family: SourceHanSansCN-Regular;

      .customname {
        color: #16181a;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        max-width: 168px;
        white-space: nowrap;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .text-comp {
        color: #98A3B7;
        font-size: 12px;
        font-weight: 400;
        width: 168px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .down-btn {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 8px 0px;
    position: relative;

    .down-btn-info {
       margin: 0px 16px;
      color: #4F5D78;
      font-family: SourceHanSansCN-Regular;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding: 8px 10px;
    }
    .down-btn-info:hover {
      border-radius: 4px;
      color: rgb(8, 111, 183);
      background: #f5f7fa;
      cursor: pointer;
    }
    .down-btn-info-active {
      border-radius: 4px;
      color: rgb(8, 111, 183);
      background: #f5f7fa;
      cursor: pointer;
    }

    .switch-user {
      position: absolute;

      right: 100%;
      top: 80px;
      border-radius: 4px;
      border: 0.5px solid #cfd5df;
      background: #fff;
      box-shadow: 0 2px 6px 0 rgba(0, 20, 51, 0.1);
      .switch-top {
        min-width: 344px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 16px;
        border-bottom: 1px solid rgba(237, 240, 244, 1);

        .switch-text {
          color: rgb(132, 146, 166);
        }
        .switch-url {
          color: rgb(8, 111, 183);
          cursor: pointer;
        }
      }
      .enterprise-list {
        padding: 0px 16px;
        overflow: hidden;
        height: 330px;
        overflow-y: auto;
        .enterprise-item {
          display: flex;
          align-items: center;
          // width: 100%;
          padding: 16px 0px;
          border-bottom: 1px solid #edf0f4;
          cursor: pointer;
          .item-img {
            width: 40px;
            height: 40px;
            border-radius: 4px;
            margin-right: 8px;
            background-color: rgba(83, 150, 255, 1);
          }
          .item-info {
            flex: 1;
            min-width: 200px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item-left {
              display: flex;
              flex-direction: column;
              .left-top {
                width: 220px;
                min-width: 220px;
                color: #333333;
                font-family: SourceHanSansCN-Regular;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .left-tag {
                margin-top: 8px;
                display: flex;
                align-items: center;
                .tag {
                  padding: 0 4px;
                  align-items: center;
                  border-radius: 2px;
                  font-family: SourceHanSansCN-Regular;
                  font-size: 10px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                  margin-right: 8px;
                }
                .tag-gy {
                  background: rgba(229, 242, 253, 1);
                  color: rgb(0, 126, 235);
                }
                .tag-cg {
                  background: rgba(254, 242, 240, 1);
                  color: rgb(240, 115, 96);
                }
                .tag-fw {
                  background: rgba(235, 253, 250, 1);
                  color: rgb(0, 221, 197);
                }
                .tag-cg-dj {
                  background: linear-gradient(
                    90deg,
                    #ebf5ff 23.86%,
                    #b5d6fb 134.09%
                  );
                  color: rgba(69, 80, 165, 1);
                }
                .tag-cg-dj1 {
                  border: 0.5px solid #ccc;
                  color: rgb(153, 153, 153);
                }
                .tag-gy-dj {
                  display: flex;
                  align-items: center;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  span {
                    color: #666666;
                    font-family: SourceHanSansCN-Regular;
                    font-size: 10px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    margin-left: 4px;
                  }
                }
              }
            }
            .item-right {
              width: 16px;
              height: 16px;
              border-radius: 8px;
              background: #086fb7;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 600;
              font-size: 10px;
              margin-left: 25px;
              min-width: 16px;
            }
          }
        }
        .enterprise-item-activate {
          // background: rgba(245, 246, 252, 1) !important;
          cursor: inherit;
        }
        .enterprise-item:hover {
          // background: rgba(245, 246, 252, 0.7);
        }
      }
      .add-comp {
        padding: 16px 16px;

        .add-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
          color: rgb(6, 110, 183);
          font-family: SourceHanSansCN-Regular;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          border-radius: 4px;
          border: 1px solid #066eb7;
          .add-icon {
            font-size: 16px;
            margin-right: 4px;
          }
        }
        .add-btn:hover {
          cursor: pointer;
          background: #f5f7fa;
        }
      }
    }
  }
    .multi {
    color: #16181a;
    font-family: "Source Han Sans CN";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 16px 27px;
    border-top: 1px solid rgba(237, 240, 244, 1);

  }
   .multi:hover {
    background: #f5f7fa;
    cursor: pointer;
  }
  .down-out {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-top: 1px solid rgba(237, 240, 244, 1);
     color: #16181A;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .down-out:hover {
    background: #f5f7fa;
    cursor: pointer;
  }
}
</style>
